export default __webpack_public_path__ + "static/media/basic-pin-large-4.9966d8be.png";